import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  Chip,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Button,
  Alert,
} from '@mui/material';
import {
  AccountTree as WorkflowIcon,
  CheckCircle as CheckCircleIcon,
  AccessTime as PendingIcon,
} from '@mui/icons-material';
import type { WorkflowDetailsDialogProps } from './types';

const WorkflowDetailsDialog: React.FC<WorkflowDetailsDialogProps> = ({
  open,
  onClose,
  workflow,
  getStatusColor,
}) => {
  if (!workflow) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <WorkflowIcon color="primary" />
          {workflow.name}
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box>
          <Box sx={{ mb: 3 }}>
            <Chip
              label={workflow.kategorie}
              color="primary"
              sx={{ mr: 1 }}
            />
            <Chip
              label={workflow.status}
              color={getStatusColor(workflow.status)}
            />
          </Box>

          {workflow.beschreibung && (
            <Typography variant="body1" sx={{ mb: 3 }}>
              {workflow.beschreibung}
            </Typography>
          )}

          <Typography variant="h6" gutterBottom>
            Zugehörige Tickets ({workflow.tickets?.length || 0})
          </Typography>

          {workflow.tickets && workflow.tickets.length > 0 ? (
            <List>
              {workflow.tickets.map((ticket) => (
                <ListItem key={ticket.ticketID} divider>
                  <ListItemIcon>
                    {ticket.status === 'Erledigt' ? (
                      <CheckCircleIcon color="success" />
                    ) : (
                      <PendingIcon color="warning" />
                    )}
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Chip label={`Schritt ${ticket.schrittNummer}`} size="small" />
                        {ticket.titel}
                      </Box>
                    }
                    secondary={
                      <Typography variant="caption" color="text.secondary">
                        Status: {ticket.status}
                        {ticket.erledigtAm && ` | Erledigt am: ${new Date(ticket.erledigtAm).toLocaleDateString('de-DE')}`}
                      </Typography>
                    }
                  />
                </ListItem>
              ))}
            </List>
          ) : (
            <Alert severity="info">Keine Tickets in diesem Workflow</Alert>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Schließen</Button>
      </DialogActions>
    </Dialog>
  );
};

export default WorkflowDetailsDialog;
